module.exports = __webpack_public_path__ + "img/volumetrie_125.62391009.png";